import { defineMessages } from "react-intl";

const messages = defineMessages({
    companyName: {
        description: "Label for organization name input",
        defaultMessage: "Name of your organization"
    },
    companyNamePlaceholder: {
        description: "Placeholder for organization name input",
        defaultMessage: "e.g. Acme Inc."
    }
});

export default messages;
